import * as React from 'react';
import { useState, useEffect } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { Tooltip } from "@material-ui/core";

import { checkboxStyle, MenuProps } from '../StyledComponent'
import { CustomDropdownIcon } from '../CustomDropDownIcon';

export const DoctorProfileStatusFilter = ({ filterArray, filterTitle, activeFilterArray, setActiveFilterArray }) => {
    const [selcetedFilter, setSelectedFilter] = useState([]);
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setSelectedFilter(activeFilterArray);
        setOpen(true);
    };

    const handleFilterSelection = () => {
        setActiveFilterArray(
            selcetedFilter
        );
        setSelectedFilter([]);
        setOpen(false);
    }

    const clearFilter = () => {
        setSelectedFilter([]);
        setActiveFilterArray((prev) => {
            return [];
        })
        setOpen(false);
    }
    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedFilter(
            typeof value === 'string' ? value.split(',') : value,
        );

    };

    return (
        <div className="flex flex-row gap-4 px-8 pb-4 w-[220px]" >
            <FormControl sx={{ padding: 0, display: 'flex', minWidth: '12.5rem' }} className='border border-solid border-gray-100 rounded-xl'>
                <p htmlFor="grouped-native-select" className="text-[#252D38] font-san text-sm font-normal leading-6 px-2 space-y-1 ">{filterTitle}</p>
                <Select
                    multiple
                    value={selcetedFilter}
                    displayEmpty
                    open={open}
                    onClose={() => setOpen(false)}
                    onOpen={handleOpen}
                    onChange={handleChange}
                    IconComponent={CustomDropdownIcon}
                    input={<OutlinedInput sx={{ padding: 0, margin: 0 }}> </OutlinedInput>}
                    renderValue={
                        () => {
                            if (activeFilterArray.length === 0) {
                                return (
                                    <div className="flex text-base" style={{ alignItems: 'center' }}>
                                        <img
                                            style={{ width: 34, height: 25 }}
                                            src="https://views.medibuddy.in/providerUi/assets/filter.svg"
                                            alt="remove filter"
                                        />
                                        <div class="overflow-hidden text-gray-700 truncate text-base font-normal leading-6 ">
                                            Set Filter
                                        </div>
                                    </div>
                                )
                            }
                            return (
                                <>
                                    <div className="flex flex-row align-center relative gap-2">
                                        <img
                                            style={{ width: 34, marginTop: 0, height: 24 }}
                                            src="https://views.medibuddy.in/providerUi/assets/filter-remove.svg"
                                            alt="remove filter"
                                            className='relative flex justify-center items-center '
                                        />
                                        <div class="overflow-hidden text-gray-700 truncate text-base font-normal leading-6 " style={{paddingRight:'1.5rem'}}>
                                            {activeFilterArray.length === 1 ? `${activeFilterArray[0]}` : `+${activeFilterArray.length} more`}
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    }
                    MenuProps={MenuProps}
                    sx={checkboxStyle}
                >
                    {filterArray.map((name) => (
                        <MenuItem
                            key={name}
                            value={name}
                            className="flex w-full flex-row border border-solid pl-2"
                            sx={{
                                padding: 0,
                                margin: 0,
                                bgcolor: '#fff',
                            }}
                        >
                            <Checkbox checked={selcetedFilter.includes(name)} />
                            <ListItemText
                                primary={ 
                                    <Tooltip title={
                                        <React.Fragment>
                                            <p className="p-1">
                                                {name
                                                    .split(' ')
                                                    .map((word, idx) => (
                                                        <div key={idx}>
                                                            {word}
                                                        </div>
                                                    ))}
                                            </p>
                                        </React.Fragment>
                                    }
                                    placement="bottom-start" arrow>
                                        <p>
                                        {name
                                            .split(' ')
                                            .map((word, idx) => (
                                                <div key={idx} className="px-2 truncate overflow-hidden">
                                                    {word}
                                                </div>
                                            ))}
                                            </p>
                                    </Tooltip>
                                    }
                                className="py-2 text-sm text-[#252D38] font-normal truncate overflow-hidden"
                            />
                        </MenuItem>
                    ))}

                    <div className="block flex w-full justify-around sticky bottom-0 bg-white py-2 border-t-2 border-solid " style={{ borderTop: '1px solid #E5E5E5', zIndex: 100 }}>
                        <button
                            className="w-1/2 rounded-lg ml-2 text-mb-red-500 py-1"
                            onClick={clearFilter}
                        >
                            Clear All
                        </button>
                        <button
                            className={`${filterArray.length > 0 ? 'bg-blue-600 ' : 'bg-gray-500 '
                                } border border-solid border-gray-100 w-1/2 rounded-lg mx-2 py-1 text-white`}
                            onClick={handleFilterSelection}
                        >
                            Apply
                        </button>
                    </div>
                </Select >
            </FormControl>
        </div>
    );
}